export default __webpack_public_path__ + "static/marco-45b907a044a01cf85800ce7ac94057ff.png";